__turbopack_context__.v({
  "comment-arrow": "nZ-VPq_comment-arrow",
  "comment-current": "nZ-VPq_comment-current",
  "comment-page": "nZ-VPq_comment-page",
  "comment-paginator": "nZ-VPq_comment-paginator",
  "comment-rating": "nZ-VPq_comment-rating",
});
